import clamp from "lodash/clamp";
import { Component } from "react";
import NoBodyBackgroundColor from "./NoBodyBackgroundColor";
import Video from "./video/Video";
import { Display } from "src/pods/ideas";
import PairShareResult from "src/pods/pairshare/components/receiver/PairShareResult";
import PresentationPage from "src/shared/components/PresentationPage";

type IdeasDisplayProps = {
  displayClose?: VoidFunction;
  sendVideoPlaybackState?: (value: boolean) => void;
  display?: Display;
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class IdeasDisplay extends Component<IdeasDisplayProps> {
  /**
   * @return {ReactElement}
   */
  render() {
    const { display, sendVideoPlaybackState, displayClose } = this.props;

    if (!display) {
      return null;
    }

    if (display.question) {
      return (
        <PresentationPage
          backgroundColor="dt_background_primary"
          closeButtonStyle={{ color: "dt_content_primary", fontSize: 40, opacity: 0.2 }}
          onRequestHide={() => displayClose?.()}
        >
          <PairShareResult question={display.question} />
        </PresentationPage>
      );
    }

    if (display.watch) {
      return (
        <PresentationPage
          backgroundColor="transparent"
          onRequestHide={() => {
            sendVideoPlaybackState?.(false);
            displayClose?.();
          }}
        >
          <div>
            <NoBodyBackgroundColor />
            <Video
              ref={(video) => {
                this.video = video;
              }}
              type={display.watch.type}
              watch={display.watch}
              autoplay={false}
              isExpanded={true}
              isFullscreen={display.isFullscreen}
              isPlaying={display.isPlaying}
              onPlaying={this.handleVideoPlaying}
              onPause={this.handleVideoPause}
              onEnd={this.handleVideoEnd}
            />
          </div>
        </PresentationPage>
      );
    }

    return null;
  }

  video: Video | null | undefined;

  /**
   * @param {Object} nextProps
   */
  UNSAFE_componentWillReceiveProps(nextProps: IdeasDisplayProps) {
    if (this.props.display?.seekOffset !== nextProps.display?.seekOffset) {
      const currentOffset = this.props.display?.seekOffset;
      const nextOffset = nextProps.display?.seekOffset;

      if (nextOffset && currentOffset) {
        const timeSeeked = nextOffset - currentOffset;
        this.video?.seek(clamp(this.video.getDuration(), 0, this.video.getCurrentTime() + timeSeeked * 1000));
      }
    }
  }

  handleVideoPlaying = () => {
    const { display, sendVideoPlaybackState } = this.props;

    if (!display?.isPlaying) {
      sendVideoPlaybackState?.(true);
    }
  };

  handleVideoPause = () => {
    const { display, sendVideoPlaybackState } = this.props;

    if (display?.isPlaying) {
      sendVideoPlaybackState?.(false);
    }
  };

  handleVideoEnd = () => this.props.sendVideoPlaybackState?.(false);
}
